import { HttpClient } from './http-client';

const config = (baseUrl: string, httpClient: HttpClient) => ({
  getDictionary: (): Promise<Record<string, string[]>> => httpClient(`${baseUrl}/config/dictionary`)
});

export default config;
